"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _HubHttpPrebuilt = _interopRequireDefault(require("email-confirm-ui/prebuilts/HubHttpPrebuilt"));

var _default = {
  injectEmailConfirmBar: function injectEmailConfirmBar() {
    return new _HubHttpPrebuilt.default();
  },
  setup: function setup() {
    return this.injectEmailConfirmBar();
  }
};
exports.default = _default;
module.exports = exports.default;